import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LanguageService } from 'app/core/i18n/language.service';
import { DocumentItemBonus } from '../../interfaces/document-item.interface';

// Icono de regalía por línea: indica que la línea comprada genera una regalía y su proporción
@Component({
  selector: 'app-bonus-cell',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatTooltipModule],
  template: `
    @if (bonus && bonus.buyQuantity) {
    <span
      class="inline-flex h-6 w-6 items-center justify-center rounded-full bg-green-100 p-1 text-green-700 dark:bg-green-900 dark:text-green-300"
      [matTooltip]="tooltip"
      matTooltipPosition="above"
    >
      <mat-icon class="icon-size-4">redeem</mat-icon>
    </span>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BonusCellComponent {
  @Input() bonus?: DocumentItemBonus;

  private readonly i18n = inject(LanguageService);

  get tooltip(): string {
    if (!this.bonus?.buyQuantity) return '';
    const parts = [
      this.i18n.t('DOCUMENT_GENERATE.BONUS_APPLIED.CELL_RULE', {
        buy: this.bonus.buyQuantity,
        bonus: this.bonus.bonusQuantity,
      }),
    ];
    if (this.bonus.minimumQuantity) {
      parts.push(
        this.i18n.t('DOCUMENT_GENERATE.BONUS_APPLIED.CELL_MINIMUM', { min: this.bonus.minimumQuantity })
      );
    }
    const scale = this.bonus.appliedScale;
    if (scale) {
      parts.push(
        this.i18n.t('DOCUMENT_GENERATE.BONUS_APPLIED.CELL_SCALE', {
          from: scale.quantityFrom,
          to: scale.quantityTo,
        })
      );
    }
    return parts.join(' · ');
  }
}
